var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNessunDifetto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_21745",
    "data-name": "Raggruppa 21745",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1334",
    "data-name": "Ellisse 1334",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#c6e0b4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M5.715,16.879.246,11.41a.841.841,0,0,1,0-1.19l1.19-1.19a.841.841,0,0,1,1.19,0L6.31,12.714,14.2,4.824a.841.841,0,0,1,1.19,0l1.19,1.19a.841.841,0,0,1,0,1.19L6.9,16.879A.841.841,0,0,1,5.715,16.879Z",
    transform: "translate(12.499 9.422)",
    fill: "#75a758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNessunDifetto);
export default __webpack_public_path__ + "static/media/nessunDifetto.ef4dcf582e30a845494b81a077da3503.svg";
export { ForwardRef as ReactComponent };